import React, { FunctionComponent } from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { getPasswordPolicy } from "../../services/userServices";
import { PasswordRules } from "./constants";
import "./index.scss";
import { API_CONFIG } from "../../config/api.config";

interface ParaPasswordPolicyProps {
    fullwidth?: boolean; // 是否全宽展示
    type?: string; // 获取密码策略后面跟的路径
    username?: string // 获取默认密码策略的用户名
}

const ParaPasswordPolicy: FunctionComponent<ParaPasswordPolicyProps> = (props) => {

    const { fullwidth, type, username } = props;
    const [policyList, setPolicyList] = React.useState<any[] | null>(null);
    const renderPolicyByPolicyList = () => {
        if (policyList) {
            return (
                <Grid container>
                    <ol className={"rule-ol"}>
                        {policyList.map((item: any, index) => {
                            if (item.key !== "allowedSpecialChars" && item.key !== "requiredRuleNum" && item.key != "isAccount") {
                                return (
                                    <li key={index}>{item.value}</li>
                                    /*<Grid item xs={fullwidth ? 12 : 4} key={index}>
                                        {/!*<Typography variant='caption' className="rules" gutterBottom>
                                            {item.value}
                                        </Typography>*!/}
    
                                        <ol>
                                            <li>{item.value}</li>
                                        </ol>
                                    </Grid>*/
                                );
                            } else {
                                /*特殊字符长度太长，另起一行*/
                                return (
                                    <li key={index}>{item.value}</li>
                                    /*<Grid item xs={12} key={index}>
                                        <Typography variant='caption' className="rules" gutterBottom>
                                            {item.value}
                                        </Typography>
                                    </Grid>*/
                                );
                            }
                        })}
                    </ol>
                </Grid>
            );
        } else {
            return null;
        }
    };
    /**
     * 陈夕 2020/7/28 上午10:05
     * desc: 根据params获取密码策略映射关系
     * @params
     **/
    const fetchPolicyByParams = async () => {
        let url = (type && type === "forget") ? (API_CONFIG.passwordPolicyDefault + "?username=" + username) : API_CONFIG.passwordPolicyLogin;
        const { data, err } = await getPasswordPolicy(url);
        if (err) return;
        if (data.code === "0") {
            const judeObject = data.data;
            setPolicyList((prev: any) => {
                prev = [];
                Object.keys(judeObject).forEach((keys: string) => {
                    // if (keys === "isAd") {
                    //     judeObject[keys] === 0 && prev.push({
                    //         key: keys, title: PasswordRules[keys],
                    //         value: "否"
                    //     });
                    // } else {
                    //     if (PasswordRules[keys] && judeObject[keys] !== false) {
                    //         prev.push({
                    //             key: keys,
                    //             title: PasswordRules[keys],
                    //             value: PasswordRules[judeObject[keys]] || judeObject[keys]
                    //         });
                    //     }
                    // }
                    switch (keys) {
                        case "minLength":
                            prev.push({ key: keys, value: `密码最小${judeObject[keys]}位` });
                            //密码最小 位
                            break;
                        case "maxLength":
                            prev.push({ key: keys, value: `密码最大${judeObject[keys]}位` });
                            //密码最大 位
                            break;
                        case "minCyc":
                            prev.push({ key: keys, value: `有效期${judeObject[keys]}天` });
                            //有效期 天
                            break;
                        case "exChar":
                            Number(judeObject[keys]) !== 0 && prev.push({
                                key: keys,
                                value: `必须包含${judeObject[keys]}位特殊字符`
                                //必须包含 位特殊字符
                            });
                            break;
                        case "maxChar":
                            Number(judeObject[keys]) !== 0 && prev.push({
                                key: keys,
                                value: `至少包含${judeObject[keys]}个大写字母`
                                //至少包含 个大写字母
                            });
                            break;
                        case "minChar":
                            Number(judeObject[keys]) !== 0 && prev.push({
                                key: keys,
                                value: `至少包含${judeObject[keys]}个小写字母`
                                //至少包含 个小写字母
                            });
                            break;
                        case "numberChar":
                            Number(judeObject[keys]) !== 0 && prev.push({
                                key: keys,
                                value: `至少包含${judeObject[keys]}个数字`
                                //至少包含 个数字
                            });
                            break;
                        case "isFirstNumber":
                            Number(judeObject[keys]) === 0 && prev.push({ key: keys, value: "不允许首位是数字" }); //不允许首位是数字
                            break;
                        case "isSpace":
                            Number(judeObject[keys]) === 0 && prev.push({ key: keys, value: "不允许包含空格" }); //不允许包含空格
                            break;
                        case "isAccount":
                            // debugger;
                            // Number(judeObject[keys]) === 0 &&
                            prev.push({ key: keys, value: "不允许含用户名" }); //不允许包含用户名
                            break;
                        case "history":
                            Number(judeObject[keys]) !== 0 && prev.push({
                                key: keys,
                                value: `不允许和前${judeObject[keys]}次密码重复`
                                //不允许和前 次密码重复
                            });
                            break;
                        case "expirePrompt":
                            break;
                        case "isAd":
                            judeObject[keys] !== 0 && prev.push({ key: keys, value: "需要符合AD用户名密码规范" });
                            //需要符合AD用户名密码规范
                            break;
                        case "allowedSpecialChars":
                            prev.push({ key: keys, value: `允许使用的特殊字符:${judeObject[keys]}` });
                            // 允许使用的特殊字符
                            break;
                        case "remindersNum":
                            break;
                        case "isWeakPwd":
                            Number(judeObject[keys]) === 0 && prev.push({ key: keys, value: "不允许弱密码" }); //不允许弱密码
                            break;
                        case "requiredRuleNum":
                            prev.push({ key: keys, value: `大写、小写、数字，特殊字符（至少符合的策略数）：${judeObject[keys]}种` });
                            //密码最小 位
                            break;
                        default:
                            break;
                    }
                });
                prev.push({ key: 'isAccount', value: '不能包含用户姓名拼音中超过2个连续字符的部分' })
                console.log("aaa=====>", prev)
                return prev;
            });
        }
    };
    React.useEffect(() => {
        fetchPolicyByParams();
        return () => {
        };
    }, []);
    return (
        <div className={"para-password-policy"}>{renderPolicyByPolicyList()}</div>
    );
};

export default ParaPasswordPolicy;
